

















import {Component, Inject, Vue} from 'vue-property-decorator';
import ApiClient from "./utils/ApiClient";
import GlobalEventBus from "./mixins/GlobalEventBus";
import UserService from "./services/UserService";
import UserStore from "./stores/UserStore";
import MessageTab from "./components/MessageTab.vue";
import ChatTab from "./components/ChatTab.vue";

@Component({
  components: {
    MessageTab,
    ChatTab
  },
})
export default class App extends Vue {
  @Inject()
  // @ts-ignore
  private apiClient: ApiClient;

  @Inject()
  // @ts-ignore
  private userService: UserService;

  @Inject()
  // @ts-ignore
  private userStore: UserStore;

  mounted() {
    window.addEventListener("message", this.receiveMessage);
    window.dispatchEvent(new Event('startup'));

  }

  beforeDestroy() {
    window.removeEventListener("message", this.receiveMessage);
  }

  private receiveMessage(event: MessageEvent) {
    if (!event.isTrusted) {
      return
    }
    if (event.data !== null && typeof (event.data) === "object") {
      if (Object.prototype.hasOwnProperty.call(event.data, 'authToken')) {
        this.apiClient.setAuthorization(event.data.authToken);
        this.userService.getUser().then(response => {
          this.userStore.data = response.data;
          GlobalEventBus.$emit('updated-auth');
          this.$forceUpdate();
        });
      }
    }
  }
}
